// prettier-ignore
//eslint-disable-next-line
const regexp = /^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/;

export const validatePhone = (phone: string) => regexp.test(phone);
